import { render, staticRenderFns } from "./ExtensionIcon.vue?vue&type=template&id=19acaed1&scoped=true&"
import script from "./ExtensionIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ExtensionIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19acaed1",
  null
  
)

export default component.exports